import React from 'react';
import './onboarding.css'
import CircleCta from '../common/circleviewcta';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

const Onboardingbasic = (props) => {
      const navigate = useNavigate();

    return (  

            <section className='main-sec-onboarding'>
                <figure className='figure-cont'>
                    <img className='img-onboarding-screen' src={props.img} alt='Onboarding-illustartions'></img>
                </figure>
                <article className='container-onboarding-card'>
                <article className='onboarding-cards'>
                    <article className='container-all-info-onboarding'>
                        <article className='sub-cont-onboarding'>
                            <h1 className='header-onboarding'>{props.title}</h1>
                            <p className='para-onboardig'>{props.parag}</p>
                        </article>
                        <nav className='navigations-container-on-boarding'>


                            <Link to ='/login'>
                                <h2 className='skipnow-onboarding'>Skip Now</h2>
                            </Link>


                                <nav className='container-mid-navigation-onboarding'>
                                    <div className={props.currentPage === 1 ? 'active-rect-onboarding' : 'circle-onboardingg'}
                                       onClick={() => navigate('/onboarding-page1')}></div>
                                    <div className={props.currentPage === 2 ? 'active-rect-onboarding' : 'circle-onboardingg'}
                                       onClick={() => navigate('/onboarding-page2')}></div>
                                    <div className={props.currentPage === 3 ? 'active-rect-onboarding' : 'circle-onboardingg'}
                                       onClick={() => navigate('/onboarding-page3')}></div>                                
                                </nav>


                                <nav className='container-cta-onboarding'>
                                    <CircleCta onClick={() => navigate(props.nextPage)}/>         
                                </nav>
                        </nav>
                </article>
                </article>


                </article>
            </section>
    );
}
 
export default Onboardingbasic;